import { MDBDatatable, MDBInput } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form";
import { fetchImpExpMiscDetails } from "../../../apiclients/streamsapi_bridge";

function ErrorValidataion({
  register,
  control,
  setValue,
  reset,
  watch,
  userDetail,
  setIsloading,
  isloading,
}) {
  const [userDetails, setuserDetails] = useState({});
  const [tempUserInfo, settempUserInfo] = useState({});
  const [servicePlanList, setservicePlanList] = useState([]);
  const [billingGroupList, setbillingGroupList] = useState([]);
  const [locationList, setlocationList] = useState([]);
  const [deleteYesNoList, setdeleteYesNoList] = useState([]);
  const [internationYesNoList, setinternationYesNoList] = useState([]);
  const [recordCallYNList, setrecordCallYNList] = useState([]);
  const [nineOlocationList, setnineOlocationList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);

  const { fields } = useFieldArray({
    control,
    name: "validate_users_data",
  });

  async function fetchMiscData() {
    try {
      setIsloading(true);
      let saverep = await fetchImpExpMiscDetails(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      let saverepeMsg = await saverep.json();
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      console.log("dropdownlist :::" + JSON.stringify(saverepeMsg));

      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setservicePlanList(saverepeMsg?.data?.servicePlansList ?? []);
        setbillingGroupList(saverepeMsg?.data?.billingGroupsList ?? []);
        setdeleteYesNoList(saverepeMsg?.data?.deleteUsersList ?? []);
        setrecordCallYNList(saverepeMsg?.data?.recordAllCallsList ?? []);
        setinternationYesNoList(
          saverepeMsg?.data?.internationalCallsList ?? []
        );
        setlocationList(saverepeMsg?.data?.locationsList ?? []);
        setnineOlocationList(saverepeMsg?.data?.nineOneLocationList ?? []);
        setDeviceList(saverepeMsg?.data?.deviceModelsList ?? []);
      } else {
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (userDetail && Object.entries(userDetail).length > 0) {
      const errorList = userDetail?.error_rows ?? [];
      if (errorList.length > 0) {
        fetchMiscData();
        const sortedErrorRows = [...errorList].sort((a, b) => a - b);
        const userInfo = sortedErrorRows.map(
          (rowId) => userDetail[rowId]?.row_info
        );
        reset({ validate_users_data: userInfo });
        setuserDetails(userDetail);
        settempUserInfo(userDetail);
      }
    }
  }, [userDetail]);

  const handleOnChangeErrors = (e, key, fieldName, index) => {
    e.preventDefault();
    let updatedValue = e.target.value;
    if (fieldName === "extension" && e.target.value !== "") {
      updatedValue = parseInt(e.target.value);
    }
    setValue(`validate_users_data.${index}.${fieldName}`, updatedValue, {
      shouldDirty: true,
    });
    settempUserInfo((prevData) => {
      if (!prevData[key]) return prevData; // If key doesn't exist, return previous state

      return {
        ...prevData,
        [key]: {
          ...prevData[key],
          error_columns: prevData[key].error_columns.filter(
            (col) => col !== fieldName
          ),
        },
      };
    });
  };

  let processRows = [];
  fields &&
    fields.forEach((info, index) => {
      const uniqueid = info.rowid;
      const errorField = tempUserInfo[uniqueid]?.error_columns;
      const errorDetails = tempUserInfo[uniqueid]?.errors;
      const errorsObject = errorDetails ?  errorDetails?.reduce(
        (acc, { param_name, message }) => {
          acc[param_name] = message ? message.replace(/"/g, "") : ""; // Remove extra quotes
          return acc;
        },
        {}
      ) : {}

      processRows.push({
        userInfo: info,
        firstName: (
          <>
            {errorsObject?.["fname"] ? (
              <>
                <MDBInput
                  value={watch(`validate_users_data.${index}.fname`)}
                  className={errorField.includes("fname") ? "errorFeild" : ""}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "fname", index)
                  }
                />
                {errorField.includes("fname") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["fname"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.fname ?? ""}</>
            )}
          </>
        ),
        lastName: (
          <>
            {errorsObject?.["lname"] ? (
              <>
                <MDBInput
                  value={watch(`validate_users_data.${index}.lname`)}
                  className={errorField.includes("lname") ? "errorFeild" : ""}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "lname", index)
                  }
                />
                {errorField.includes("lname") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["lname"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.lname ?? ""}</>
            )}
          </>
        ),
        email: (
          <>
            {errorsObject?.["emailid"] ? (
              <>
                <MDBInput
                  value={watch(`validate_users_data.${index}.emailid`)}
                  className={errorField.includes("emailid") ? "errorFeild" : ""}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "emailid", index)
                  }
                />
                {errorField.includes("emailid") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["emailid"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.emailid ?? ""}</>
            )}
          </>
        ),
        extension: (
          <>
            {errorsObject?.["extension"] ? (
              <>
                <MDBInput
                  value={
                    watch(`validate_users_data.${index}.extension`) 
                  }
                  className={
                    errorField.includes("extension") ? "errorFeild" : ""
                  }
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  maxLength={5}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "extension", index)
                  }
                />
                {errorField.includes("extension") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["extension"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.extension ?? ""}</>
            )}
          </>
        ),
        servicePlan: (
          <>
            {errorsObject["serviceplan"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${
                    errorField.includes("serviceplan") ? " errorFeild" : ""
                  }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.serviceplan`)}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "serviceplan", index)
                  }
                >
                  <option value="">--Select Plan--</option>
                  {servicePlanList &&
                    servicePlanList.length > 0 &&
                    servicePlanList.map((plan) => (
                      <option value={plan}>{plan}</option>
                    ))}
                </select>
                {errorField.includes("serviceplan") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["serviceplan"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.serviceplan ?? ""}</>
            )}
          </>
        ),
        classtype: (
          <>
            {errorsObject && errorsObject["classtype"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${errorField.includes("classtype") ? " errorFeild" : ""
                    }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.classtype`)}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "classtype", index)
                  }
                >
                  {internationYesNoList &&
                    internationYesNoList.length > 0 &&
                    internationYesNoList.map((call) => (
                      <option value={call}>{call}</option>
                    ))}
                </select>
                {errorField.includes("recordallcalls") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["classtype"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.classtype ?? ""}</>
            )}
          </>
        ),
        callerId: (
          <>
            {errorsObject?.["caller_id"] ? (
              <>
                <MDBInput
                  value={watch(`validate_users_data.${index}.caller_id`)}
                  className={
                    errorField.includes("caller_id") ? "errorFeild" : ""
                  }
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "caller_id", index)
                  }
                />
                {errorField.includes("caller_id") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["caller_id"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.caller_id ?? ""}</>
            )}
          </>
        ),
        did: (
          <>
            {errorsObject?.["added_dids"] ? (
              <>
                <MDBInput
                  value={watch(`validate_users_data.${index}.added_dids`)}
                  className={
                    errorField.includes("added_dids") ? "errorFeild" : ""
                  }
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "added_dids", index)
                  }
                />
                {errorField.includes("added_dids") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["added_dids"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.added_dids ?? ""}</>
            )}
          </>
        ),
        location: (
          <>
            {errorsObject?.["location"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${
                    errorField.includes("location") ? " errorFeild" : ""
                  }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.location`)}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "location", index)
                  }
                >
                  <option value="">--Select Location--</option>
                  {locationList &&
                    locationList.length > 0 &&
                    locationList.map((loc) => (
                      <option value={loc}>{loc}</option>
                    ))}
                </select>
                {errorField.includes("location") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["location"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.location ?? ""}</>
            )}
          </>
        ),
        recordallcalls: (
          <>
            {errorsObject && errorsObject["recordallcalls"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${
                    errorField.includes("recordallcalls") ? " errorFeild" : ""
                  }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.recordallcalls`)}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "recordallcalls", index)
                  }
                >
                  {recordCallYNList &&
                    recordCallYNList.length > 0 &&
                    recordCallYNList.map((call) => (
                      <option value={call}>{call}</option>
                    ))}
                </select>
                {errorField.includes("recordallcalls") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["recordallcalls"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.recordallcalls ?? ""}</>
            )}
          </>
        ),
        billinggroup: (
          <>
            {errorsObject && errorsObject["billinggroup"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${
                    errorField.includes("billinggroup") ? " errorFeild" : ""
                  }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.billinggroup`)}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "billinggroup", index)
                  }
                >
                  <option value="">--Select Billing Group--</option>
                  {billingGroupList &&
                    billingGroupList.length > 0 &&
                    billingGroupList.map((grp) => (
                      <option value={grp}>{grp}</option>
                    ))}
                </select>
                {errorField.includes("billinggroup") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["billinggroup"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.billinggroup ?? ""}</>
            )}
          </>
        ),
        ip1no_mla: (
          <>
            {errorsObject?.["ip1no_mla"] ? (
              <>
                <MDBInput
                  value={watch(`validate_users_data.${index}.ip1no_mla`)}
                  className={
                    errorField.includes("ip1no_mla") ? "errorFeild" : ""
                  }
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "ip1no_mla", index)
                  }
                />
                {errorField.includes("ip1no_mla") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["ip1no_mla"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.ip1no_mla ?? ""}</>
            )}
          </>
        ),
        ip2no_mla: (
          <>
            {errorsObject?.["ip2no_mla"] ? (
              <>
                <MDBInput
                  value={watch(`validate_users_data.${index}.ip2no_mla`)}
                  className={
                    errorField.includes("ip2no_mla") ? "errorFeild" : ""
                  }
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "ip2no_mla", index)
                  }
                />
                {errorField.includes("ip2no_mla") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["ip2no_mla"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.ip2no_mla ?? ""}</>
            )}
          </>
        ),
        // ip1lable: (
        //   <>
        //     {errorsObject["ip1lable"] ? (
        //       <>
        //         <MDBInput
        //           value={watch(`validate_users_data.${index}.ip1lable`)}
        //           className={errorField.includes("ip1lable") ? "errorFeild" : ""}
        //           onChange={(e) =>
        //             handleOnChangeErrors(e, info.rowid, "ip1lable", index)
        //           }
        //         />
        //         {errorField.includes("ip1lable") && (
        //           <p className="text-danger text-small text-left">{errorsObject["ip1lable"]}</p>
        //         )}
        //       </>
        //     ) : (
        //       <>{info?.ip1lable ?? ""}</>
        //     )}
        //   </>
        // ),
        // ip2lable: (
        //   <>
        //     {errorsObject["ip2lable"] ? (
        //       <>
        //         <MDBInput
        //           value={watch(`validate_users_data.${index}.ip2lable`)}
        //           className={errorField.includes("ip2lable") ? "errorFeild" : ""}
        //           onChange={(e) =>
        //             handleOnChangeErrors(e, info.rowid, "ip2lable", index)
        //           }
        //         />
        //         {errorField.includes("ip2lable") && (
        //           <p className="text-danger text-small text-left">{errorsObject["ip2lable"]}</p>
        //         )}
        //       </>
        //     ) : (
        //       <>{info?.ip2lable ?? ""}</>
        //     )}
        //   </>
        // ),
        ip1macaddress: (
          <>
            {errorsObject?.["ip1macaddress"] ? (
              <>
                <MDBInput
                  value={watch(`validate_users_data.${index}.ip1macaddress`)}
                  className={
                    errorField.includes("ip1macaddress") ? "errorFeild" : ""
                  }
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "ip1macaddress", index)
                  }
                />
                {errorField.includes("ip1macaddress") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["ip1macaddress"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.ip1macaddress ?? ""}</>
            )}
          </>
        ),
        ip1model: (
          <>
            {errorsObject && errorsObject["ip1model"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${
                    errorField.includes("ip1model") ? " errorFeild" : ""
                  }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.ip1model`)}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "ip1model", index)
                  }
                >
                  <option value="">--Select IP1 Phone Mac--</option>
                  {deviceList &&
                    deviceList.length > 0 &&
                    deviceList.map((grp) => <option value={grp}>{grp}</option>)}
                </select>
                {errorField.includes("ip1model") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["ip1model"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.ip1model ?? ""}</>
            )}
          </>
        ),
        ip1nineolocation: (
          <>
            {errorsObject && errorsObject["ip1nineolocation"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${
                    errorField.includes("ip1nineolocation") ? " errorFeild" : ""
                  }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.ip1nineolocation`)}
                  onChange={(e) =>
                    handleOnChangeErrors(
                      e,
                      info.rowid,
                      "ip1nineolocation",
                      index
                    )
                  }
                >
                  <option value="">--Select 911 Location--</option>

                  {nineOlocationList &&
                    nineOlocationList.length > 0 &&
                    nineOlocationList.map((grp) => (
                      <option value={grp}>{grp}</option>
                    ))}
                </select>
                {errorField.includes("ip1nineolocation") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["ip1nineolocation"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.ip1nineolocation ?? ""}</>
            )}
          </>
        ),
        ip2macaddress: (
          <>
            {errorsObject?.["ip2macaddress"] ? (
              <>
                <MDBInput
                  value={watch(`validate_users_data.${index}.ip2macaddress`)}
                  className={
                    errorField.includes("ip2macaddress") ? "errorFeild" : ""
                  }
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "ip2macaddress", index)
                  }
                />
                {errorField.includes("ip2macaddress") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["ip2macaddress"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.ip2macaddress ?? ""}</>
            )}
          </>
        ),
        ip2model: (
          <>
            {errorsObject && errorsObject["ip2model"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${
                    errorField.includes("ip2model") ? " errorFeild" : ""
                  }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.ip2model`)}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "ip2model", index)
                  }
                >
                  <option value="">--Select IP2 Phone Mac--</option>
                  {deviceList &&
                    deviceList.length > 0 &&
                    deviceList.map((grp) => <option value={grp}>{grp}</option>)}
                </select>
                {errorField.includes("ip2model") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["ip2model"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.ip2model ?? ""}</>
            )}
          </>
        ),
        ip2nineolocation: (
          <>
            {errorsObject && errorsObject["ip2nineolocation"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${
                    errorField.includes("ip2nineolocation") ? " errorFeild" : ""
                  }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.ip2nineolocation`)}
                  onChange={(e) =>
                    handleOnChangeErrors(
                      e,
                      info.rowid,
                      "ip2nineolocation",
                      index
                    )
                  }
                >
                  <option value="">--Select 911 Location--</option>
                  {nineOlocationList &&
                    nineOlocationList.length > 0 &&
                    nineOlocationList.map((grp) => (
                      <option value={grp}>{grp}</option>
                    ))}
                </select>
                {errorField.includes("ip2nineolocation") && (
                  <p className="text-danger text-small text-left">
                    {errorsObject["ip2nineolocation"]}
                  </p>
                )}
              </>
            ) : (
              <>{info?.ip2nineolocation ?? ""}</>
            )}
          </>
        ),
        ip1mla: (
          <>
            {errorsObject && errorsObject["ip1mla"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${errorField.includes("ip1mla") ? " errorFeild" : ""
                    }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.ip1mla`)}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "ip1mla", index)
                  }
                >
                  <option value="">--Select 911 Location--</option>
                  {deleteYesNoList &&
                    deleteYesNoList.length > 0 &&
                    deleteYesNoList.map((grp) => (
                      <option value={grp}>{grp}</option>
                    ))}
                </select>
                {errorField.includes("ip1mla") && (
                  <p className="text-danger text-small text-left">{errorsObject["ip1mla"]}</p>
                )}
              </>
            ) : (
              <>{info?.ip1mla ?? ""}</>
            )}
          </>
        ),
        ip2mla: (
          <>
            {errorsObject && errorsObject["ip2mla"] ? (
              <>
                <select
                  className={`form-control form-select selectname w-100 ${errorField.includes("ip2mla") ? " errorFeild" : ""
                    }`}
                  name="San Jose"
                  value={watch(`validate_users_data.${index}.ip2mla`)}
                  onChange={(e) =>
                    handleOnChangeErrors(e, info.rowid, "ip2mla", index)
                  }
                >
                  <option value="">--Select 911 Location--</option>
                  {deleteYesNoList &&
                    deleteYesNoList.length > 0 &&
                    deleteYesNoList.map((grp) => (
                      <option value={grp}>{grp}</option>
                    ))}
                </select>
                {errorField.includes("ip2mla") && (
                  <p className="text-danger text-small text-left">{errorsObject["ip2mla"]}</p>
                )}
              </>
            ) : (
              <>{info?.ip2mla ?? ""}</>
            )}
          </>
        ),
       
      });
    });

  const actionData4 = {
    columns: [
      { label: "First Name", field: "firstName", sort: false },
      { label: "Last Name", field: "lastName", sort: false },
      { label: "Email Address", field: "email", sort: false },
      // { label: 'User ID', field: 'userId', sort: false },
      { label: "Extension", field: "extension", sort: false },
      { label: "Service Plan", field: "servicePlan", sort: false },
      { label: "International Calling Enabled", field: "classtype", sort: false },
      // { label: 'Contract Term', field: 'contractTerm', sort: false },
      // { label: 'Intl. Calling Enabled?', field: 'intlCalling', sort: false },
      // { label: 'MLA', field: 'mla', sort: false },
      // { label: 'No. of MLA Lines', field: 'mlaLines', sort: false },
      { label: "Caller ID", field: "callerId", sort: false },
      { label: "DID", field: "did", sort: false },
      // { label: 'Phone Password', field: 'phonePassword', sort: false },
      // { label: 'Voicemail PIN', field: 'voicemailPin', sort: false },
      // { label: 'IP1 Mac ID', field: 'ip1MacId', sort: false },
      { label: "Location", field: "location", sort: false },
      { label: "Record All Calls", field: "recordallcalls", sort: false },
      { label: "Billing Group", field: "billinggroup", sort: false },
      { label: "IP1 Mac ID", field: "ip1macaddress", sort: false },
      { label: "IP1 911 Location", field: "ip1nineolocation", sort: false },
      { label: "IP1 Phone Make", field: "ip1model", sort: false },
      { label: "IP1 MLA", field: "ip1mla", sort: false },
      { label: "IP1 No. of MLA Lines", field: "ip1no_mla", sort: false },
      // { label: "IP1 Phone Label", field: "ip1lable", sort: false },
      { label: "IP2 Mac ID", field: "ip2macaddress", sort: false },
      { label: "IP1 911 Location", field: "ip2nineolocation", sort: false },
      { label: "IP2 Phone Make", field: "ip2model", sort: false },
      { label: "IP2 MLA", field: "ip2mla", sort: false },
      { label: "IP2 No. of MLA Lines", field: "ip2no_mla", sort: false },
      // { label: "IP2 Phone Label", field: "ip2lable", sort: false },

      // { label: 'A ction', field: 'action', sort: false },
    ],
    rows: processRows,
  };

  return (
    <>
      <div
        className="my-2 text-left fs-6 p-3 bg-danger bg-opacity-10 border-danger border border-3"
        light
      >
        <strong>
          The following invalid data has been found in the Spread Sheet which
          cannot be used to create/edit the user(s) -{" "}
          {userDetails?.error_rows?.length ?? 0} Record(s)
        </strong>
      </div>
      {/* <strong>Note: The Voicemail PIN and Extension will be Auto generated if the respective fields are empty. Voicemail Pin is not applicable for Common Extension User(s). </strong> */}
      <div className="importExportDatatable">
        <div className="actionbar"></div>
        <MDBDatatable
          search
          fixedHeader
          maxHeight="600px"
          minHeight="240px"
          hover
          className="actioncolumnbig"
          pagination={true}
          data={actionData4}
          sortField="Name"
        />
      </div>
    </>
  );
}

export default ErrorValidataion;
